import React, { FunctionComponent } from "react";
import { Card, List, useTheme } from "@mui/material";
import styles from "./styles.module.scss";
import { PiperDivider } from "../../../PiperDivider";
import { GearItemListItem } from "../GearItemListItem";
import { IEquipmentGearItem } from "../../../../hooks/equipments/interfaces";
import { IGearItem } from "../../../../hooks/gearItems";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { arrayMoveMutable } from "array-move";
import { ContentUnavailableNotice } from "../../ContentUnavailableNotice";
import { IconType } from "../../../../icons";
import { strings } from "../../../../localization/LocalizedStrings";

export const GearItemsList: FunctionComponent<IGearItemsListProps> = ({
  className,
  gearItems,
  onDelete
}) => {
  const theme = useTheme();
  return (
    <Card className={className} elevation={5}>
      <DragDropContext
        onDragEnd={result => {
          if (!gearItems || !result.destination || result.source.index === result.destination.index)
            return;
          arrayMoveMutable(gearItems, result.source.index, result.destination.index);
        }}
      >
        <Droppable droppableId={"gear_items_droppable"}>
          {provided => (
            <List
              key={"gear_items_droppable"}
              className={styles.list}
              disablePadding
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {gearItems
                .map(equipmentGearItem => equipmentGearItem.gearItem)
                .map((gearItem, index) => (
                  <Draggable
                    key={`${gearItem.uuid}_draggable_div`}
                    draggableId={`${gearItem.uuid}_draggable`}
                    index={index}
                  >
                    {provided => (
                      <div
                        key={`${gearItem.uuid}_item`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <GearItemListItem
                          gearItem={gearItem}
                          onDelete={() => onDelete(gearItem, index)}
                        />
                        {index < gearItems.length - 1 && (
                          <PiperDivider color={theme.palette.background.paper} />
                        )}
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
              <ContentUnavailableNotice
                isLoading={false}
                items={gearItems}
                emptyIconType={IconType.AudioVideoReceiver}
                emptyTitle={strings.empty_equipment_gear_items}
                emptyDescription={""}
                searchText={""}
                canAdd={false}
              />
            </List>
          )}
        </Droppable>
      </DragDropContext>
    </Card>
  );
};

export interface IGearItemsListProps {
  className?: string;
  gearItems: IEquipmentGearItem[];
  onDelete: (gearItem: IGearItem, index: number) => void;
}
